<header id="header">
  <div class="wrap">
      <a href="/WorkingPlace/Index" class="logo four-i"></a>
                      <div class="menuMobile" style="display:none;" id="mobile">
      <div class="containerMenu" onclick="OpenMenu(this)">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
      </div>
      <nav class="adaptive-nav">
          <div class="page-width" id="page-width">
              <div class="adaptive-nav-scroll">
                  <ul class="menu__links">
                      <li class="main-menu-adaptive__item">
                          <a href="/WorkingPlace/Index" class="logo four-i logo-mobile"></a>
                      </li>
                  </ul>
              </div>
          </div>
      </nav>
  </div>
      

<div class="right">
<div class="header-auth">
</div>
      </div>
      <div class="clear"></div>
  </div>
</header>
